<template>
  <div class="app" >

<table style="width:100%">
  <tr>
    <th>Chemin</th>
    <th>Nom</th> 
  </tr>
  <tr v-for="r in routes">
    <td>{{r.path}}</td>
    <td>{{r.name}}</td> 
  </tr>
 
</table>



  </div>
</template>


<script>
  export default {
    name: 'app',
    data () {
      return {
        valid: true,
        routes:[],
      }
    },
    methods: {
      load () {
        this.routes = this.$router.options.routes
      }
    },
     mounted () {
      this.load()
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/Routes.vue